// Dispara la descarga de un blob en el navegador vía <a download> efímero
// (mismo patrón que la descarga de Data ERP). Función pura de DOM: sin
// notificaciones ni estado — el caller maneja toasts y loading.
export function downloadBlob(data, filename) {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
}
